import { useMemo } from 'react'
import { roundToNearestInterval } from '../utils/orderUtils'
import { getCashRoundingEnabled, getCashRoundingMinimumCurrencyInCents } from '../selectors/menus'
import { useSelector } from 'react-redux'

const useCashRounding = ({ totalInCents }) => {
  const cashRoundingEnabled = useSelector(getCashRoundingEnabled)
  const cashRoundingMinimumCurrencyInCents = useSelector(getCashRoundingMinimumCurrencyInCents)

  const roundedTotal = useMemo(() => {
    if (!cashRoundingEnabled) return totalInCents

    return roundToNearestInterval({ amountInCents: totalInCents, cashRoundingMinimumCurrencyInCents })
  }, [totalInCents, cashRoundingEnabled, cashRoundingMinimumCurrencyInCents])

  const cashRoundingInCents = useMemo(() => roundedTotal - totalInCents, [roundedTotal, totalInCents])

  const cashRounded = useMemo(() => roundedTotal !== totalInCents, [roundedTotal, totalInCents])

  return { cashRounded, roundedTotal, cashRoundingInCents }
}

export default useCashRounding
